export const GET_CATRGORIES = "GET_CATRGORIES";
export const SET_CATRGORIES = "SET_CATRGORIES";
export const SET_DEFAULT_LANGUAGE_AND_CURRENCY = "SET_DEFAULT_LANGUAGE_AND_CURRENCY";